import { App } from './app.store';
import { LoadableStore } from './loadable.store';

export class ThemeStore implements LoadableStore {
    appStore: App;

    constructor(appStore: App) {
        this.appStore = appStore;
        appStore.registerStore('theme', this);
    }

    async load(): Promise<boolean> {
        return true;
    }

    setRootTheme(): void {
        const htmlElement = document.querySelector('html');
        if (htmlElement) {
            const style = htmlElement.style;

            for (const key of ['--primary']) {
                const color = '#fff';
                style.setProperty(key, color);
            }
        }

    }

    /**
     * Takes image retrieved from the server and
     * processes data to find the dominant color
     * and accent colors.
     * see: https://github.com/briangonzalez/rgbaster.js/blob/master/src/helpers.ts
     */
    setImageData(data: string): void {
        // TODO: implement
    }
}